import React from 'react'
import PropTypes from 'prop-types'
import Box from '../box/Box'
import Text from '../typography/text/Text'

type Props = {|
  color?: 'darkGray' | 'orange',
  icon?: 'arrow-circle-forward', // leaving open to additional icons in the future
  text: string | Array<string>,
  thumbnail?: React.Element<any>,
|};

export default function Toast(props: Props) {
  const { color = 'darkGray', icon, thumbnail, text } = props

  let contents
  // Confirmation Toasts
  if (text instanceof Array && text.length > 1) {
    contents = (
      <Box display='flex'>
        <Box display='flex' direction='column' justifyContent="center">
          {thumbnail ? (
            <Box shape="round" height='48px' width='48px'>
              {thumbnail}
            </Box>
          ) : null}
        </Box>
        <Box
          display='flex'
          direction='column'
          justifyContent="center"
          dangerouslySetInlineStyle={{ __style: { paddingLeft: 10 } }}
        >
          <Box
            dangerouslySetInlineStyle={{ __style: { fontWeight: 'normal' } }}
          >
            <Text color="white" size="lg">
              {text[0]}
            </Text>
          </Box>
          <Text fontWeight='medium' color="white" size="lg">
            {text[1]}
          </Text>
        </Box>
      </Box>
    )
  } else {
    // Toasts as Guides
    contents = (
      <Box
        display='flex'
        justifyContent="between"
        alignItems="center"
      >
        <Text fontWeight='medium' color="white" size="lg">
          {text}
        </Text>
        {icon && (
          <Box dangerouslySetInlineStyle={{ __style: { paddingLeft: 24 } }}>
            {
              //TODO: icons
            }
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box paddingX={4} maxWidth={376} width="100vw">
      <Box color={color} maxWidth='100%' paddingX={8} paddingY={5} shape="circle">
        {contents}
      </Box>
    </Box>
  )
}

Toast.propTypes = {
  color: PropTypes.oneOf(['darkGray', 'orange']),
  icon: PropTypes.oneOf(['arrow-circle-forward']), // leaving open to additional icons in the future
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  thumbnail: PropTypes.element,
}



// WEBPACK FOOTER //
// ./src/core/components/toasts/Toast.js